import { OverflowMenu } from 'src/shared/design-system/OverflowMenu';
import styled from 'styled-components';
import { Colors, Font, Spacing, Transition } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  transition: opacity ${Transition.Time.BASE};
`;

export const DateHeader = styled.div`
  color: ${Colors.GRAY_DARK_10};
  text-align: left;
  width: 100%;
  ${Font.bySize(Font.Size.XXS, Font.Weight.NORMAL)};

  &:only-child {
    color: ${Colors.GRAY};
    text-transform: uppercase;
    ${Font.bySize(Font.Size.XXS, Font.Weight.SEMI_BOLD)};
  }
`;

export const ShefInfoContainer = styled.div`
  display: flex;
  flex: 1 1 100%;
  gap: ${Spacing.HALF};
`;

export const ShefInfo = styled.div`
  ${Font.bySize(Font.Size.XS, Font.Weight.NORMAL)};
`;

export const ShefImage = styled.img`
  border-radius: ${Spacing.DOUBLE};
  height: ${Spacing.DOUBLE};
  width: ${Spacing.DOUBLE};
`;

export const MenuContainer = styled.div`
  color: ${Colors.GRAY_DARK_10};

  & button {
    height: auto;
    width: auto;
  }
`;

export const Menu = styled(OverflowMenu).attrs(() => ({
  isVerticalIcon: true,
}))``;

export const LikeContainer = styled.div`
  align-items: flex-start;
  display: flex;
  gap: ${Spacing.QUARTER};
`;
